export const useDragScroll = () => {
  let mouseDown = false;
  let startX, scrollLeft;
  const slider = document.querySelector(".carousel-wrapper");
  function startDragging(e) {
    mouseDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  }
  function move(e) {
    e.preventDefault();
    if (!mouseDown) {
      return;
    }
    const x = e.pageX - slider.offsetLeft;
    const scroll = x - startX;
    slider.scrollLeft = scrollLeft - scroll;
  }
  function stopDragging(e) {
    mouseDown = false;
  }
  return {
    startDragging,
    move,
    stopDragging
  }
};
